var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","overflow-y":"auto"}},[_c('v-subheader',[_vm._v("Interactions")]),_c('Form',{attrs:{"lead":_vm.lead,"opportunity":_vm.opportunity},on:{"update":_vm.update}}),_vm._l((_vm.items),function(interaction){return _c('Cell',{key:interaction._id,attrs:{"interaction":interaction}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }